import styled from 'styled-components';
import { Modal } from 'antd';

// Shared by VAMS_PC_004 (FixedAssetLedger) 承認/差し戻し confirm — same visual pattern as
// FixedAssetLedgerDetail's SaveConfirmModalWrapper (formerly VAMS_PC_009_01).
export const ApproveReturnModalWrapper = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(5, 40, 97, 0.12);
  }

  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid var(--color-border-primary, #e5e7eb);
    margin-bottom: 0;

    .ant-modal-title {
      font-weight: var(--font-bold);
      font-size: var(--font-size-base);
    }
  }

  .ant-modal-body {
    padding: 20px 24px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 24px 20px;
    margin-top: 0;
  }

  .approve-return-confirm_message {
    margin: 0 0 16px;
  }
`;
